import 'nodelist-foreach-polyfill';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import './modal.scss';

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.createElement('div');
  modal.classList.add('modal');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  document.body.appendChild(modal);
  const closeButton = document.createElement('button');
  closeButton.innerHTML = '×';
  closeButton.classList.add('modal__close');
  modal.appendChild(closeButton);
  const modalContent = document.createElement('div');
  modalContent.classList.add('modal__content');
  modal.appendChild(modalContent);

  function close() {
    modal.classList.remove('modal_opened');
    enableBodyScroll(modal);
    setTimeout(() => {
      modalContent.innerHTML = '';
    }, 300);
  }

  closeButton.addEventListener('click', close);
  document.querySelectorAll('[data-modal-wrapper]').forEach((wrapper) => {
    const toggle = wrapper.querySelector('[data-modal-toggle]');
    const content = wrapper.querySelector('[data-modal-content]');

    function open() {
      modalContent.innerHTML = content.innerHTML;
      modal.classList.add('modal_opened');
      disableBodyScroll(modal);
      document.body.style.marginRight = '';
    }

    toggle.addEventListener('click', open);
    toggle.addEventListener('keydown', (e) => {
      switch (e.keyCode) {
        case 13:
        case 32:
          open();
          break;
        default: //
      }
    });
  });
  window.addEventListener('keydown', (e) => {
    switch (e.keyCode) {
      case 27:
        close();
        break;
      default: //
    }
  });
});
